//@flow
import type {PaginationRequest} from '..';
import type {ConversationMessage, MessageRequest} from './message';

export type MessageScheduleSendType = 'DEFAULT' | 'CLIENT_DOES_NOT_RESPOND';
export type MessageScheduleState = 'PENDING' | 'SENT' | 'ERROR' | 'ARCHIVED';
export type ScheduleMessage = {
  createdAt: number,
  crmScheduledMessageSendType: MessageScheduleSendType,
  crmScheduledMessageState: MessageScheduleState,
  id: string,
  message: ConversationMessage,
  sendAt: number,
  sentAt?: number,
  type: string,
  updatedAt: number,
};

export type CreateScheduleMessageRequest = {
  message: MessageRequest,
  crmScheduledMessageSendType: MessageScheduleSendType,
  sendAt: string,
};

export type EditScheduleMessageRequest = {
  message?: MessageRequest,
  crmScheduledMessageSendType?: MessageScheduleSendType,
  sendAt?: string,
};

export type ListScheduleMessageRequest = {
  states?: MessageScheduleState[],
  crmConversationId?: string,
} & PaginationRequest;

export const SCHEDULE_MESSAGE_SEND_TYPE = {
  DEFAULT: 'DEFAULT',
  CLIENT_DOES_NOT_RESPOND: 'CLIENT_DOES_NOT_RESPOND',
};

export const SCHEDULE_MESSAGE_STATE = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  ERROR: 'ERROR',
  ARCHIVED: 'ARCHIVED',
};
